import React from 'react';
import s from './s.module.less';
import { Prospect, ProspectForm } from 'types/common';
import { getTimeStr } from 'utils/calendar';
import dayjs from 'utils/dayjs';
import CommonTable from 'components/CommonTable';
import { ColumnsType } from 'antd/es/table';
import useProspectForms from 'hooks/useProspectForms';
import axios from 'axios';
import { getScheduleToken, getUserId, getUserToken } from 'utils/localstore';
import { baseURL } from 'api';
import useCurrentUser from 'hooks/useCurrentUser';

type Props = {
    prospect?: Prospect;
    hasPlan?: boolean;
    isGroupPractice?: boolean;
};

const Forms = (props: Props) => {
    const { prospect, hasPlan, isGroupPractice } = props;
    const clientId = isGroupPractice ? prospect?.identityId : prospect?.id;
    const [datas, loading] = useProspectForms(clientId || 0, isGroupPractice);
    const [loadingDownload, setLoadingDownload] = React.useState(false);
    const [currentUser] = useCurrentUser();

    // const downloadFileWithBlob = (pdfData: string, fileName: string) => {
    //     try {
    //         const blob = new Blob([pdfData], { type: 'application/pdf' });
    //         const downloadUrl = window.URL.createObjectURL(blob);

    //         // 创建一个隐藏的 <a> 元素
    //         const a = document.createElement('a');
    //         a.style.display = 'none';
    //         a.href = downloadUrl;
    //         a.download = fileName;

    //         // 将 <a> 元素添加到文档中并触发点击事件以启动下载
    //         document.body.appendChild(a);
    //         a.click();

    //         // 清理
    //         window.URL.revokeObjectURL(downloadUrl);
    //         document.body.removeChild(a);
    //     } catch (e) {
    //         console.error(e);
    //     }
    // };
    const handleDownload = async (item: ProspectForm) => {
        try {
            setLoadingDownload(true);
            const downloadProspectId = isGroupPractice && item.prospectId ? item.prospectId : prospect?.id;
            const url = `${baseURL}schedule-server/prospect/form/download/${downloadProspectId}/${item.consentType}`;
            //const isActingAsOther = `${getUserId()}` !== `${item.provider?.providerId}`;

            const response = await axios.get(url, {
                responseType: 'blob',
                headers: {
                    accept: 'application/json, text/plain, */*',
                    'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
                    'cache-control': 'no-cache',
                    origin: `${baseURL}`,
                    pragma: 'no-cache',
                    priority: 'u=1, i',
                    referer: `${baseURL}`,
                    // 'sec-ch-ua': '"Google Chrome";v="135", "Not-A.Brand";v="8", "Chromium";v="135"',
                    // 'sec-ch-ua-mobile': '?0',
                    // 'sec-ch-ua-platform': '"macOS"',
                    // 'sec-fetch-dest': 'empty',
                    // 'sec-fetch-mode': 'cors',
                    // 'sec-fetch-site': 'cross-site',
                    'schedule-token': getScheduleToken(),
                    ...(isGroupPractice ? { 'OVERRIDE-PROVIDER-ID': String(item.provider?.providerId) } : {}),
                    // 'user-agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/135.0.0.0 Safari/537.36',
                    // 'Cookie': 'AWSALB=HH/eRDC1k7Dn6U2etvWV4a4ZkQCrxxBlk1kwXGDIoCiDu+gynKNqanH4yzp59vf8Gi3IXv45aZlQRcOmy9vP7YP5MvPl82D33rnWWonlXyKt7wASSlOUgKXp3LTD; AWSALBCORS=HH/eRDC1k7Dn6U2etvWV4a4ZkQCrxxBlk1kwXGDIoCiDu+gynKNqanH4yzp59vf8Gi3IXv45aZlQRcOmy9vP7YP5MvPl82D33rnWWonlXyKt7wASSlOUgKXp3LTD'
                },
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = downloadUrl;
            a.download = `${prospect?.id}_${item.consentType}.pdf`; // 可以根据需要调整

            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(downloadUrl);
            document.body.removeChild(a);
            // const res = await downloadProspectForms(prospect?.id!, item.consentType);
            // if (!res.error) {
            //     downloadFileWithBlob(res.data, prospect?.id + 'pdf');
            // }
            setLoadingDownload(false);
        } catch (e) {
            setLoadingDownload(false);
        }
    };

    const columns: ColumnsType<ProspectForm> = [
        {
            title: 'FILE',
            dataIndex: 'consentType',
            width: '300px',
            render: (name: string, item: ProspectForm) => {
                return <div className={s.nameWrap}>{name}</div>;
            },
        },
        ...(isGroupPractice
            ? [
                  {
                      title: 'PROVIDER',
                      dataIndex: 'provider',
                      width: '200px',
                      render: (_: any, item: ProspectForm) => {
                          const name = item.provider
                              ? `${item.provider.firstName || ''} ${item.provider.lastName || ''}`.trim()
                              : '';
                          return <div className={s.nameWrap}>{name}</div>;
                      },
                  },
              ]
            : []),
        {
            title: 'DATE CREATED',
            dataIndex: 'createdAt',
            width: '150px',
            render: (name: string, item: ProspectForm) => {
                return (
                    <div className={s.nameWrap}>
                        {item.createdAt ? getTimeStr(dayjs(item.createdAt), 'MM/DD/YYYY') : ''}
                    </div>
                );
            },
        },
        {
            title: 'DATE MODIFIED',
            dataIndex: 'updatedAt',
            width: '150px',
            render: (name: string, item: ProspectForm) => {
                return (
                    <div className={s.nameWrap}>
                        {item.createdAt ? getTimeStr(dayjs(item.createdAt), 'MM/DD/YYYY') : ''}
                    </div>
                );
            },
        },
        {
            title: '',
            dataIndex: '',
            render: (name: string, item: ProspectForm) => {
                return (
                    <div
                        onClick={() => {
                            handleDownload(item);
                        }}
                        className={s.nameWrapD}
                    >
                        Download
                    </div>
                );
            },
        },
    ];
    return (
        <div className={s.wrap}>
            <CommonTable
                bordered
                rowKey="id"
                loading={loading || loadingDownload}
                columns={columns}
                data={datas || []}
                pagination={false}
                locale={{
                    emptyText: 'No forms available.',
                }}
                scroll={{ x: '1200' }}
            />
        </div>
    );
};

export default Forms;
